import axios from 'axios';
import React, { useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../Context/AuthContext';
import { useFormik } from 'formik';
import { object, string } from 'yup';


export default function Login() {
    // const { saveUserInfo } = useContext(AuthContext)
    // let navigate = useNavigate();
    // const [errorMessage, setErrorMessage] = useState('')
    // const [isLoading, setIsLoading] = useState(false);
    // const [errorsList, setErrorsList] = useState([])
    // const [userData, setUserData] = useState({
    //     'email': '',
    //     'password': '',
    // })

    // function getInputValue(e) {
    //     let myUser = { ...userData }
    //     myUser[e.target.name] = e.target.value;
    //     setUserData(myUser);
    // };
    // async function sendUserDataToApi() {
    //     let { data } = await axios.post(`https://route-ecommerce-app.vercel.app/api/v1/auth/signin`, userData)
    //     if (data.message === "success") {
    //         setIsLoading(false);
    //         localStorage.setItem('userToken', data.token);
    //         navToHome()
    //     } else {
    //         setErrorMessage(data.message);
    //         console.log(errorMessage);
    //         setIsLoading(false);
    //     }
    // }
    // function submitFormData(e) {
    //     e.preventDefault(); //to prevent reload on submit
    //     setIsLoading(true);
    //     let validationResult = validateFormData();
    //     if (validationResult.error) {
    //         setIsLoading(false);
    //         setErrorsList(validationResult.error.details);
    //     } else {
    //         sendUserDataToApi();
    //     }
    // };
    // function validateFormData() {
    //     let schema = Joi.object({
    //         email: Joi.string().email({ minDomainSegments: 2, tlds: { allow: ['com', 'net'] } }).required(),
    //         password: Joi.string().pattern(new RegExp(/^[A-Z][a-z]{3,6}/)),
    //     });
    //     return schema.validate(userData, { abortEarly: false });
    // }
    // function navToHome() {
    //     saveUserInfo()
    //     navigate('/')
    // };

    const { saveUserToken } = useContext(AuthContext)
    let navigate = useNavigate()
    const [errorMessage, setErrorMessage] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    let validationSchema = object({
        email: string().email().required(),
        password: string().matches(/^(?=.*[A-Za-z])(?=.*\d)*([@$!%*#?&])*[A-Za-z\d@$!%*#?&.]{6,32}$/, "password must match the pattern").required(),
    });

    let registerFormik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema,
        onSubmit: async (values) => {
            setIsLoading(true)
            axios.post(`https://ecommerce-be-sand.vercel.app/auth/login`, values).then((response) => {
                if (response.data.message === "Login Done") {
                    setIsLoading(false)
                    localStorage.setItem("authorization", response.data.token);
                    navigate('/')
                    saveUserToken()
                }
                // console.log(response);
            }).catch((error) => {
                if (error.response) {
                    setIsLoading(false)
                    setErrorMessage(error.response.data.error)
                }
            })
        }
    })

    return (
        <div className="container my-5">
            <h2 className="text-center mb-5">Login Form </h2>
            <div className="row g-3 align-items-center justify-content-center">
                {errorMessage ? <div className="bg-red-500 py-2 px-3 w-full text-gray-50 rounded my-2">{errorMessage}</div> : ""}
                <form className="px-4" onSubmit={registerFormik.handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email address</label>
                        <input onBlur={registerFormik.handleBlur}
                            value={registerFormik.values.email}
                            onChange={registerFormik.handleChange} type="email" className="form-control" id="email" name='email' />
                        {registerFormik.errors.email && registerFormik.touched.email ?
                            <div className=" py-1 text-red-600 my-2">{registerFormik.errors.email}</div> : ""}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Password</label>
                        <input onBlur={registerFormik.handleBlur}
                            value={registerFormik.values.password}
                            onChange={registerFormik.handleChange} type="password" className="form-control" id="password" name='password' />
                        {registerFormik.errors.password && registerFormik.touched.password ?
                            <div className=" py-1 text-red-600 my-2">{registerFormik.errors.password}</div> : ""}
                    </div>
                    <button disabled={registerFormik.isValid && registerFormik.dirty && !isLoading ? false : true} type="submit" className="btn btn-outline-warning my-2 px-5">{isLoading ? <i className="fas fa-spinner fa-spin"></i> : 'Login'}</button>
                </form>
                <div className="text-center ">Don't have account? <Link className="text-warning" to="/register">Register</Link></div>
            </div>
        </div>
    )
}
